import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '../../../typings'
import { ISalesFunnel } from '@user/store/salesFunnel'

type Props = {
  name: string
}

export function useHandlers(props: Props) {
  const { name } = props
  const { setFieldValue } = useFormikContext<ILeadFormModel>()

  const handleChange = useCallback(
    (value: ISalesFunnel | null) => {
      setFieldValue(name, value?.id ?? '')
    },
    [setFieldValue, name],
  )

  return {
    handleChange,
  }
}
